import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
export var userMediaRequested = false;
export var mountedInstances = [];

function requestLegacyUserMediaAsync(props) {
  var optionalSource, constraintToSourceId, sources, audioSource, videoSource, audioSourceId, videoSourceId;
  return _regeneratorRuntime.async(function requestLegacyUserMediaAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          optionalSource = function optionalSource(id) {
            return {
              optional: [{
                sourceId: id
              }]
            };
          };

          constraintToSourceId = function constraintToSourceId(constraint) {
            var deviceId = constraint.deviceId;

            if (typeof deviceId === 'string') {
              return deviceId;
            }

            if (Array.isArray(deviceId) && deviceId.length > 0) {
              return deviceId[0];
            }

            if (typeof deviceId === 'object' && deviceId.ideal) {
              return deviceId.ideal;
            }

            return null;
          };

          _context.next = 4;
          return _regeneratorRuntime.awrap(new Promise(function (resolve) {
            return MediaStreamTrack.getSources(function (sources) {
              return resolve(sources);
            });
          }));

        case 4:
          sources = _context.sent;
          audioSource = null;
          videoSource = null;
          sources.forEach(function (source) {
            if (source.kind === 'audio') {
              audioSource = source.id;
            } else if (source.kind === 'video') {
              videoSource = source.id;
            }
          });
          audioSourceId = constraintToSourceId(props.audioConstraints);

          if (audioSourceId) {
            audioSource = audioSourceId;
          }

          videoSourceId = constraintToSourceId(props.videoConstraints);

          if (videoSourceId) {
            videoSource = videoSourceId;
          }

          return _context.abrupt("return", [optionalSource(audioSource), optionalSource(videoSource)]);

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
}

function sourceSelectedAsync(isMuted, audioConstraints, videoConstraints) {
  var constraints;
  return _regeneratorRuntime.async(function sourceSelectedAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          constraints = {
            video: typeof videoConstraints !== 'undefined' ? videoConstraints : true
          };

          if (!isMuted) {
            constraints.audio = typeof audioConstraints !== 'undefined' ? audioConstraints : true;
          }

          _context2.next = 4;
          return _regeneratorRuntime.awrap(getAnyUserMediaAsync(constraints));

        case 4:
          return _context2.abrupt("return", _context2.sent);

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, null, null, null, Promise);
}

export function requestUserMediaAsync(props) {
  var isMuted,
      _await$requestLegacyU,
      _await$requestLegacyU2,
      audio,
      video,
      _args3 = arguments;

  return _regeneratorRuntime.async(function requestUserMediaAsync$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          isMuted = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;

          if (!canGetUserMedia()) {
            _context3.next = 5;
            break;
          }

          _context3.next = 4;
          return _regeneratorRuntime.awrap(sourceSelectedAsync(isMuted, props.audio, props.video));

        case 4:
          return _context3.abrupt("return", _context3.sent);

        case 5:
          _context3.next = 7;
          return _regeneratorRuntime.awrap(requestLegacyUserMediaAsync(props));

        case 7:
          _await$requestLegacyU = _context3.sent;
          _await$requestLegacyU2 = _slicedToArray(_await$requestLegacyU, 2);
          audio = _await$requestLegacyU2[0];
          video = _await$requestLegacyU2[1];
          _context3.next = 13;
          return _regeneratorRuntime.awrap(sourceSelectedAsync(isMuted, audio, video));

        case 13:
          return _context3.abrupt("return", _context3.sent);

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, null, null, null, Promise);
}
export function getAnyUserMediaAsync(constraints) {
  var ignoreConstraints,
      _args4 = arguments;
  return _regeneratorRuntime.async(function getAnyUserMediaAsync$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          ignoreConstraints = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
          _context4.prev = 1;
          _context4.next = 4;
          return _regeneratorRuntime.awrap(getUserMediaAsync(_objectSpread(_objectSpread({}, constraints), {}, {
            video: ignoreConstraints || constraints.video
          })));

        case 4:
          return _context4.abrupt("return", _context4.sent);

        case 7:
          _context4.prev = 7;
          _context4.t0 = _context4["catch"](1);

          if (!(!ignoreConstraints && _context4.t0.name === 'ConstraintNotSatisfiedError')) {
            _context4.next = 13;
            break;
          }

          _context4.next = 12;
          return _regeneratorRuntime.awrap(getAnyUserMediaAsync(constraints, true));

        case 12:
          return _context4.abrupt("return", _context4.sent);

        case 13:
          throw _context4.t0;

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, null, null, [[1, 7]], Promise);
}
export function getUserMediaAsync(constraints) {
  var _getUserMedia;

  return _regeneratorRuntime.async(function getUserMediaAsync$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
            _context5.next = 2;
            break;
          }

          return _context5.abrupt("return", navigator.mediaDevices.getUserMedia(constraints));

        case 2:
          _getUserMedia = navigator['mozGetUserMedia'] || navigator['webkitGetUserMedia'] || navigator['msGetUserMedia'];
          return _context5.abrupt("return", new Promise(function (resolve, reject) {
            return _getUserMedia.call(navigator, constraints, resolve, reject);
          }));

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, null, null, null, Promise);
}
export function canGetUserMedia() {
  return canUseDOM && !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia || navigator['mozGetUserMedia'] || navigator['webkitGetUserMedia'] || navigator['msGetUserMedia']);
}
export function isFrontCameraAvailableAsync(devices) {
  return _regeneratorRuntime.async(function isFrontCameraAvailableAsync$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return _regeneratorRuntime.awrap(supportsCameraType(['front', 'user'], 'user', devices));

        case 2:
          return _context6.abrupt("return", _context6.sent);

        case 3:
        case "end":
          return _context6.stop();
      }
    }
  }, null, null, null, Promise);
}
export function isBackCameraAvailableAsync(devices) {
  return _regeneratorRuntime.async(function isBackCameraAvailableAsync$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return _regeneratorRuntime.awrap(supportsCameraType(['back', 'rear'], 'environment', devices));

        case 2:
          return _context7.abrupt("return", _context7.sent);

        case 3:
        case "end":
          return _context7.stop();
      }
    }
  }, null, null, null, Promise);
}

function supportsCameraType(labels, type, devices) {
  var cameras, _cameras$filter, _cameras$filter2, hasCamera, _cameras$filter3, _cameras$filter4, isCapable;

  return _regeneratorRuntime.async(function supportsCameraType$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (devices) {
            _context8.next = 6;
            break;
          }

          if (navigator.mediaDevices.enumerateDevices) {
            _context8.next = 3;
            break;
          }

          return _context8.abrupt("return", null);

        case 3:
          _context8.next = 5;
          return _regeneratorRuntime.awrap(navigator.mediaDevices.enumerateDevices());

        case 5:
          devices = _context8.sent;

        case 6:
          cameras = devices.filter(function (t) {
            return t.kind === 'videoinput';
          });
          _cameras$filter = cameras.filter(function (camera) {
            return labels.includes(camera.label.toLowerCase());
          }), _cameras$filter2 = _slicedToArray(_cameras$filter, 1), hasCamera = _cameras$filter2[0];
          _cameras$filter3 = cameras.filter(function (camera) {
            if (!('getCapabilities' in camera)) {
              return null;
            }

            var capabilities = camera.getCapabilities();

            if (!capabilities.facingMode) {
              return null;
            }

            return capabilities.facingMode.find(function (_) {
              return type;
            });
          }), _cameras$filter4 = _slicedToArray(_cameras$filter3, 1), isCapable = _cameras$filter4[0];
          return _context8.abrupt("return", isCapable.deviceId || hasCamera.deviceId || null);

        case 10:
        case "end":
          return _context8.stop();
      }
    }
  }, null, null, null, Promise);
}